import GoalCategoryTable from './GoalCategoryTable';

export default GoalCategoryTable;
